module.exports = __webpack_public_path__ + "static/media/fa-regular-400.5b1cd2e2.woff";